import { Pipe, PipeTransform } from '@angular/core';

import strip from 'striptags';

@Pipe({
    name: 'filterHTML',
})
export class FilterHTMLPipe implements PipeTransform {
    transform(value: any, args?: any): any {
        return strip(value, [
            'a',
            'em',
            'li',
            'mark',
            'strong',
            'ul',
        ]);
    }
}



// WEBPACK FOOTER //
// /Users/tom/Projects/mercit2018/src/app/pipes/filter-html.pipe.ts